// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__d_NUj","container":"styles_container__1PJBu","title":"styles_title__34i34","wrapper":"styles_wrapper__3syUf","answer":"styles_answer__14G-c"};